/**
 * Mirrors packages/shared/src/constants/website-hive-prospect-intent.ts
 * (tenant-client dev container does not always resolve @shared until shared is mounted).
 */

/** Query param on the Amber Peak prospect portal URL from thehivekingston.com. */
export const WEBSITE_HIVE_PROSPECT_INTENT_QUERY = 'hiveProspectIntent';

/** Cookie name on the Hive marketing site (first-party). */
export const HIVE_SITE_PROSPECT_INTENT_COOKIE = 'hive_prospect_intent';

/** Cookie + sessionStorage on app.amberpeak.ca after the handoff param is seen. */
export const TENANT_PORTAL_HIVE_PROSPECT_INTENT_COOKIE = 'amber_peak_hive_prospect_intent';
export const TENANT_PORTAL_HIVE_PROSPECT_INTENT_STORAGE = 'amber-peak-hive-prospect-intent';

export const WEBSITE_HIVE_PROSPECT_INTENT_VALUE = '1';

/** 90 days — long enough to survive Auth0 redirect and return visits before signup completes. */
export const WEBSITE_HIVE_PROSPECT_INTENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 90;
